<ol class="etapas-servico" aria-label="Etapas da solicitação">
  @for (etapa of etapas(); track etapa; let i = $index) {
    <li
      class="etapas-servico-item"
      [attr.data-situacao]="situacaoDaEtapa(i)"
      [attr.aria-current]="i === etapaAtual() ? 'step' : null"
    >
      <button
        type="button"
        class="etapas-servico-botao"
        [disabled]="bloqueada(i)"
        [attr.title]="bloqueada(i) ? mensagemBloqueio() : null"
        (click)="selecionar.emit(i)"
      >
        <span class="etapas-servico-numero" aria-hidden="true">{{ i + 1 }}</span>
        <span class="etapas-servico-titulo">{{ etapa }}</span>
      </button>

      @if (i < etapas().length - 1) {
        <span class="etapas-servico-linha" aria-hidden="true"></span>
      }
    </li>
  }
</ol>
